import { WorldLogo as WorldLogoIcon } from '@assets/icons';
import { Row } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';

import {
  WorldLogoLabel,
  WorldLogoText,
  Wrapper,
  WrapperContent,
} from './styled';

interface WorldLogoProps {
  label?: string;
}

const WorldLogo = ({ label }: WorldLogoProps) => {
  return (
    <Wrapper>
      <WrapperContent>
        <Row alignItems='center'>
          <CustomIcon icon={WorldLogoIcon} width={75} height={12} />
          <WorldLogoLabel>‘e özel</WorldLogoLabel>
        </Row>
        <WorldLogoText>{label} fırsatı!</WorldLogoText>
      </WrapperContent>
    </Wrapper>
  );
};

export default WorldLogo;
